export const PROD_DATA_LIST_KEY = 'preferenceType=Layout,entity=Workspace';
export const PROD_DATA_LIST_NAME = 'Workspace Header';
